import type { LoanTypeT } from '@consumer-frontend/api';
import type { StateCodeT } from '@consumer-frontend/shared';

export const STEP_KEYS = {
  AUTH: 'agreement',
  FUNDS: 'funds',
} as const;

export type ContractStepKeyT = (typeof STEP_KEYS)[keyof typeof STEP_KEYS];

export type ContractFlowStepT = {
  key: ContractStepKeyT;
  label: string;
};

export type ContractFlowInputsT = {
  loanType: LoanTypeT;
  stateCode?: StateCodeT;
};

const STEPS: Record<ContractStepKeyT, ContractFlowStepT> = {
  [STEP_KEYS.AUTH]: { key: STEP_KEYS.AUTH, label: 'Sign Agreement' },
  [STEP_KEYS.FUNDS]: { key: STEP_KEYS.FUNDS, label: 'Your Funds' },
};

const DEFAULT_LOC_STEPS: ContractStepKeyT[] = [STEP_KEYS.FUNDS, STEP_KEYS.AUTH];

const DEFAULT_INSTALLMENT_STEPS: ContractStepKeyT[] = [STEP_KEYS.AUTH, STEP_KEYS.FUNDS];

const SUPPORTED_LOAN_TYPES: string[] = ['oec', 'installment'];

export const isSupportedContractLoanType = (
  loanType: string,
): boolean => SUPPORTED_LOAN_TYPES.includes(loanType);

// State-specific overrides — add TN, DE, etc. here as needed
const LOC_STEPS_BY_STATE: Partial<Record<string, ContractStepKeyT[]>> = {
  // TN: [...],
  // DE: [...],
};

export const getContractSteps = ({
  loanType,
  stateCode,
}: ContractFlowInputsT): ContractFlowStepT[] => {
  const keys = loanType === 'oec'
    ? (stateCode && LOC_STEPS_BY_STATE[stateCode.toUpperCase()]) || DEFAULT_LOC_STEPS
    : DEFAULT_INSTALLMENT_STEPS;

  return keys.map((key) => STEPS[key]);
};
